export default "__VITE_ASSET__yy7yThLf__"